import React, { ChangeEvent, Component } from "react";
import fishbowlDarkLogo from "../../../../assets/images/fishbowl/fishbowl-corporate-logo(horizontal-lg-use)-dark.png";
import fishbowlLightLogo from "../../../../assets/images/fishbowl/fishbowl-corporate-logo(horizontal-lg-use).png";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IFishbowlConnectDTO from "../../../../models/DTO/IFishbowlConnectDTO";
import IFishbowlGetQueueDTO from "../../../../models/DTO/IFishbowlGetQueueDTO";
import IFishbowlLogoutDTO from "../../../../models/DTO/IFishbowlLogoutDTO";
import IFishbowlOnConnectDTO from "../../../../models/DTO/IFishbowlOnConnectDTO";
import IFishbowlOnGetQueueDTO from "../../../../models/DTO/IFishbowlOnGetQueueDTO";
import IFishbowlOnLogoutDTO from "../../../../models/DTO/IFishbowlOnLogoutDTO";
import ILoadDashboardDTO from "../../../../models/DTO/ILoadDashboardDTO";
import IOnUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IOnUpdateSupplierIntegrationsDTO";
import IUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IUpdateSupplierIntegrationsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IFishbowl_Queue from "../../../../models/IFishbowl_Queue";
import INotification from "../../../../models/INotification";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import OwButton from "../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import "./FishbowlConnect.scss";
import { Socket } from "socket.io-client";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    isMainViewLight?: boolean;
};

type State = {
    fishbowl_host?: string | null;
    fishbowl_port?: string | null;
    fishbowl_username?: string | null;
    fishbowl_password?: string | null;
    fishbowl_auto_refresh_inventory?: boolean;
    fishbowl_auto_pull_shipments?: boolean;
    queue: IFishbowl_Queue[];
};

export default class FishbowlConnect extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            fishbowl_host: this.props.supplierModel.Supplier_Integration.fishbowl_host,
            fishbowl_port: this.props.supplierModel.Supplier_Integration.fishbowl_port,
            fishbowl_username: "",
            fishbowl_password: "",
            fishbowl_auto_refresh_inventory: this.props.supplierModel.Supplier_Integration.fishbowl_auto_refresh_inventory || false,
            fishbowl_auto_pull_shipments: this.props.supplierModel.Supplier_Integration.fishbowl_auto_pull_shipments || false,
            queue: [],
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.SupplierOnUpdateSupplierIntegrations, this.onUpdateSupplierIntegrations);
        this.props.socket.on(EndpointsEnum.FishbowlOnConnect, this.onFishbowlConnect);
        this.props.socket.on(EndpointsEnum.FishbowlOnGetQueue, this.onFishbowlGetQueue);
        // this.props.socket.on(EndpointsEnum.FishbowlOnLogout, this.onLogout);

        if (this.props.supplierModel.Supplier_Integration.has_fishbowl) {
            this.fishbowlGetQueue();
        }
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.SupplierOnUpdateSupplierIntegrations, this.onUpdateSupplierIntegrations);
        this.props.socket.removeListener(EndpointsEnum.FishbowlOnConnect, this.onFishbowlConnect);
        this.props.socket.on(EndpointsEnum.FishbowlOnGetQueue, this.onFishbowlGetQueue);
        // this.props.socket.removeListener(EndpointsEnum.FishbowlOnLogout, this.onLogout);
    }

    getDisconnect = () => {
        return <div></div>;
    };

    fishbowlGetQueue = () => {
        const payload: IFishbowlGetQueueDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.FishbowlGetQueue, payload);
    };

    onFishbowlGetQueue = (data: IFishbowlOnGetQueueDTO) => {
        this.setState({
            queue: data.queue,
        });
    };

    saveCredentials = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {},
        };

        if (this.state.fishbowl_username) {
            payload.Supplier_Integration.fishbowl_username = this.state.fishbowl_username;
        }

        if (this.state.fishbowl_password) {
            payload.Supplier_Integration.fishbowl_password = this.state.fishbowl_password;
        }

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    saveFishbowlDetails = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                fishbowl_auto_refresh_inventory: this.state.fishbowl_auto_refresh_inventory,
                fishbowl_auto_pull_shipments: this.state.fishbowl_auto_pull_shipments,
            },
        };

        if (this.state.fishbowl_host) {
            payload.Supplier_Integration.fishbowl_host = this.state.fishbowl_host;
        }

        if (this.state.fishbowl_port) {
            payload.Supplier_Integration.fishbowl_port = this.state.fishbowl_port;
        }

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    // logout = () => {
    //     let payload: IFishbowlLogoutDTO = {
    //         userGuid: this.props.userModel.guid,
    //         userToken: this.props.userModel.token,
    //         supplierGuid: this.props.supplierModel.guid,
    //     }
    //
    //     this.props.socket.emit(EndpointsEnum.FishbowlLogout, payload);
    // }

    // onLogout = (data: IFishbowlOnLogoutDTO) => {
    //     this.loadDashboard();
    // }

    loadDashboard = () => {
        const payload: ILoadDashboardDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
        };

        this.props.socket.emit(EndpointsEnum.DashboardLoadDashboard, payload);
    };

    connect = () => {
        const payload: IFishbowlConnectDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.FishbowlConnect, payload);
    };

    onFishbowlConnect = (data: IFishbowlOnConnectDTO) => {
        const notification: INotification = {
            message: "successfully_connected_to_fishbowl",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.loadDashboard();
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    toggleFishbowl = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                has_fishbowl: !this.props.supplierModel.Supplier_Integration.has_fishbowl,
            },
        };

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    onUpdateSupplierIntegrations = (data: IOnUpdateSupplierIntegrationsDTO) => {};

    getFishbowlConnection = () => {
        if (!this.props.supplierModel.Supplier_Integration.has_fishbowl) {
            return null;
        }

        if (this.props.supplierModel.Supplier_Integration.fishbowl_logged_in) {
            // return <OwButton title={'logout'} fn={this.logout}/>;
        }

        return (
            <div className={""}>
                <div>
                    <div className={"mt-2"}>
                        <OwLabel title={"username"} />
                        <OwInputWrapper
                            name={"fishbowl_username"}
                            value={this.state.fishbowl_username}
                            fn={this.handleChange}
                            autoComplete={"off"}
                        />
                        {this.props.supplierModel.Supplier_Integration.fishbowl_username?.length ? (
                            <OwLabel className={"text-success"} title={"username_set"} />
                        ) : null}
                    </div>
                    <div className={"mt-2"}>
                        <OwLabel title={"password"} />
                        <OwInputWrapper
                            type={"password"}
                            name={"fishbowl_password"}
                            value={this.state.fishbowl_password}
                            fn={this.handleChange}
                            autoComplete={"off"}
                        />
                        {this.props.supplierModel.Supplier_Integration.fishbowl_password?.length ? (
                            <OwLabel className={"text-success"} title={"password_set"} />
                        ) : null}
                    </div>

                    <div className={"mt-3"}>
                        <OwButton title={"save_credentials"} fn={this.saveCredentials} />
                    </div>
                </div>

                <div className={"mt-5"}>
                    <div>
                        <OwLabel title={"host"} />
                        <OwInputWrapper name={"fishbowl_host"} value={this.state.fishbowl_host} fn={this.handleChange} />
                    </div>
                    <div className={"mt-2"}>
                        <OwLabel title={"port"} />
                        <OwInputWrapper type={"number"} name={"fishbowl_port"} value={this.state.fishbowl_port || 28192} fn={this.handleChange} />
                    </div>
                </div>

                <div className={"mt-4"}>
                    <OwToggle
                        fn={this.handleChange}
                        name={"fishbowl_auto_refresh_inventory"}
                        label={"fishbowl_auto_refresh_inventory"}
                        active={!!this.state.fishbowl_auto_refresh_inventory}
                    />
                </div>
                <div className={"mt-2"}>
                    <OwToggle
                        fn={this.handleChange}
                        name={"fishbowl_auto_pull_shipments"}
                        label={"fishbowl_auto_pull_shipments"}
                        active={!!this.state.fishbowl_auto_pull_shipments}
                    />
                </div>
                <div className={"mt-4"}>
                    <OwButton title={"save"} className={"btn-danger me-2"} fn={this.saveFishbowlDetails} />
                    <OwButton title={"authorize"} fn={this.connect} />
                </div>
                <div className={"mt-2"}>
                    {this.props.supplierModel.Supplier_Integration.fishbowl_approved ? (
                        <OwLabel title={"fishbowl_integrated_app_approved"} className={"text-success"} />
                    ) : (
                        <OwLabel title={"fishbowl_integrated_app_awaiting_approval"} className={"text-danger"} />
                    )}
                </div>

                <div>
                    <div>
                        <OwLabel title={"queue"} />
                    </div>
                    <div>
                        {this.state.queue.map((queueItem) => {
                            return (
                                <div key={queueItem.guid}>
                                    {queueItem.queue_type} - {queueItem.state}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    render() {
        let fishbowlLogo = fishbowlDarkLogo;

        if (this.props.isMainViewLight) {
            fishbowlLogo = fishbowlLightLogo;
        }

        return (
            <div className={"FishbowlConnect"}>
                <OwAccordion
                    leftImage={fishbowlLogo}
                    leftImageHeight={30}
                    leftImageAlt={"Fishbowl"}
                    titleClick={true}
                    rightElem={
                        <div className={"ms-auto"}>
                            <OwToggle
                                fn={this.toggleFishbowl}
                                name={"has_fishbowl"}
                                label={""}
                                active={!!this.props.supplierModel.Supplier_Integration.has_fishbowl}
                            />
                        </div>
                    }>
                    <div className={"d-flex flex-column "}>
                        <div>{this.getFishbowlConnection()}</div>
                    </div>
                </OwAccordion>
            </div>
        );
    }
}
